import { useEffect, useState } from 'react'
import type { ClaimPresentPositions } from '@api-sdk'
import { useSsoToken } from './useSsoToken'
import { getPresentPositionOptions } from '../services/claimsApi'
import { getApiErrorMessage } from '../utils/errorMessages'
import type { ApiSlice } from './useClaimDetails'

const initialSlice: ApiSlice<ClaimPresentPositions[]> = { data: null, loading: false, error: null }

// Fetches the selectable present positions (current statuses) for a claim.
export function usePresentPositionOptions(claimNumber: string): ApiSlice<ClaimPresentPositions[]> {
  const { getToken } = useSsoToken()
  const [state, setState] = useState<ApiSlice<ClaimPresentPositions[]>>(initialSlice)

  useEffect(() => {
    let cancelled = false

    async function load() {
      setState({ data: null, loading: true, error: null })
      try {
        const token = await getToken()
        const data = await getPresentPositionOptions(claimNumber, token)
        if (!cancelled) setState({ data, loading: false, error: null })
      } catch (err) {
        if (cancelled) return
        console.error('[PresentPositionOptions] Load failed:', err)
        setState({
          data: null,
          loading: false,
          error: getApiErrorMessage(err, 'Failed to load position options.'),
        })
      }
    }

    load()
    return () => {
      cancelled = true
    }
  }, [claimNumber, getToken])

  return state
}
